import React from 'react';
import useUserStore from '../stores/userStore';
import Usuario from '../model/Usuario/Usuario';
import { PermissaoEnum } from '../model/Usuario/Permissao';

interface PermissaoBancaWrapperProps {
    children: React.ReactNode;
    permissoesRequiridas: PermissaoEnum[];
    bancaId: string;
    verificarQualquerPermissao?: boolean;
}

const PermissaoBancaWrapper: React.FC<PermissaoBancaWrapperProps> = ({
    children,
    permissoesRequiridas,
    bancaId,
    verificarQualquerPermissao = false,
}) => {
    const usuario = useUserStore((state) => state.usuario) as Usuario | null;

    // Se o usuário não estiver autenticado ou não tiver perfil, não renderiza nada
    if (!usuario || !usuario.perfil) {
        return <></>;
    }

    // Extrai as permissões do usuário
    const permissoesUsuario = usuario.perfil.permissoes.map((p) => p.nome);

    // Gera as permissões com bancaId no formato permissao-bancaId
    const permissoesComBancaId = permissoesRequiridas.map((p) => `${p}-${bancaId}`);

    // Verifica se o usuário tem as permissões necessárias
    const hasRequiredPermissoes = verificarQualquerPermissao
        ? permissoesComBancaId.some((p) => permissoesUsuario.includes(p))
        : permissoesComBancaId.every((p) => permissoesUsuario.includes(p));

    // Renderiza os children apenas se o usuário tiver as permissões necessárias
    return hasRequiredPermissoes ? <>{children}</> : <></>;
};

export default PermissaoBancaWrapper;